
import LoadSimple from "../../LoadSimple";
import Modal from 'react-modal';
import ModalDeleteBrand from "./ModalDeleteBrand";
import { useState, useEffect } from "react";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
import ModalHostList from "./ModalHostLis";
const hostListModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "90%",
    padding: "20px",
  },
};
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'30%',
    height:'20%',
    padding:'20px'
  },
};
const MedicionesList = ({
  pageActual,auxPool,setAuxPool,
  limitList,startLimit,
  dataList,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  setSearchTerm,
  cisSelected,
  setCisSelected,
  languaje,
  mode,
  rowSelected,
  poolRows,
  handleShowPopup,
  buscar_cis,
  loadingList,
}) => {
  const [deleteUserModalOpen, setDeleteUserModalOpen] =useState(false);
  const [userSelected,setUserSelected]=useState({})
  const [hostsListModalOpen, setHostsListModalOpen] =useState(false);
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setSearchTerm("")
    setDeleteUserModalOpen(false);
  }
  const handledeleteUserClick = (data) => {
        
    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  function openHostsListModal() {
   setHostsListModalOpen(true);
 }

  function closHostsListModal() {
    
    setHostsListModalOpen(false);
  }
  const [source,setSource]=useState('')
  const handleHostLisClick = (data,source) => {
    setSource(source)
    openHostsListModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  const handlePoolAuth = (elemento) => () => {
    if (auxPool.includes(elemento.id)) {
      auxPool.splice(auxPool.indexOf(elemento.id), 1);
      setAuxPool([...auxPool]);
    } else {
      auxPool.push(elemento.id);
      setAuxPool([...auxPool]);
    }
  }
  const cisSelectRow = (elemento) => {
    setCisSelected(elemento);
  };
  return (
    <>
      <div className="cont-row-user-list">
        {loadingList ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio"+mode}
                key={indice}
                style={{height:'45px',background:(elemento.type=='GRUPO')?'#9e9d9d2e':'transparent'}}
              >
                 
                <div className="field-body-table-mantenimiento field-small">
                  {elemento.id}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'20%'}}>
                  {elemento.name}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'20%'}}>
                  {elemento.type}
                </div>
                 
                <div className="field-body-table-mantenimiento field-larger fieldWFstatus" style={{width:'20%'}}>
                  <div style={{width:'35%'}} className="infoWFerror">
                  <img
                    src={
                      "/iconos/review.png"
                    } 
                    onClick={()=>handleHostLisClick(elemento,'disconnected_hosts')}
                    name="Ver"  title='Ver' className="btnAction delteException" style={{width:'65%'}}
                  />
                  </div>
                  {elemento.total_ci}
                </div>
                <div className="field-body-table-mantenimiento field-larger"style={{width:'20%'}}>
                  {(elemento.parent_name==null)?'N/A':elemento.parent_name}
                </div>
                {/* <div className="field-body-table-mantenimiento field-larger"style={{width:'20%'}}>
                 
                    <input type="radio" disabled={elemento.type=='GRUPO'}  checked={auxPool.includes(elemento.id)} onClick={handlePoolAuth(elemento)}></input>
                </div> */}
               
               
                
                
                {/* <div className="field-body-table-mantenimiento field-larger"style={{width:'20%'}}>
                  {
                    
                    <>
                    <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/editar.png"
                    } 
                    onClick={()=>handleChangEdit(elemento)}
                    name="Editar" title="Editar" className="btnAction delteException" style={{width:'45%'}}
                  />
                  </div>
                  
                  <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/delete.png"
                    } 
                    onClick={()=>handledeleteUserClick(elemento)}
                    name="Eliminar"  title='Eliminar' className="btnAction delteException" style={{width:'45%'}}
                  />
                  </div>
                    </>
                  }
                  
                </div> */}
              </div>
            ))
        )}
        { dataList.length == 0 ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalDeleteBrand  handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteBrand>
    </Modal>
    <Modal
        isOpen={hostsListModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closHostsListModal}
        style={hostListModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalHostList  source ={source} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode}  server={server} setData={setData} setLoading={setLoading} setError={setError} brand={userSelected} closHostsListModal={closHostsListModal}></ModalHostList>
    </Modal>
    </>
  );
};

export default MedicionesList;
